import { render, staticRenderFns } from "./dots-dropdown.vue?vue&type=template&id=ab85b21a&scoped=true"
import script from "./dots-dropdown.vue?vue&type=script&lang=js"
export * from "./dots-dropdown.vue?vue&type=script&lang=js"
import style0 from "./dots-dropdown.vue?vue&type=style&index=0&id=ab85b21a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab85b21a",
  null
  
)

export default component.exports